<template>
  <div class="login-wrap">
    <!-- <h3 class="title">{{ GET_APPNAME }}</h3> -->
    <h3 class="title">海盐经济开发区化工园区封闭管理系统</h3>
    <div class="login-container">
      <div class="form">
        <el-form label-position="left" :model="userForm" :rules="rules" ref="userForm">
          <el-form-item prop="userAccount">
            <el-input
              type="text"
              v-model="userForm.userAccount"
              auto-complete="off"
              placeholder="账号"
              @keyup.enter.native="submitForm('userForm')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="userPassword" class="u-position-relative">
            <el-input
              :key="passwordType"
              ref="password"
              v-model="userForm.userPassword"
              :type="passwordType"
              placeholder="请输入密码"
              name="password"
              auto-complete="on"
              @keyup.enter.native="submitForm('userForm')"
            />
            <span
              class="u-position-absolute u-r-10 u-b-0 u-z-index-1000"
              style="color: #fff; font-size: 0.24rem"
              @click="showPwd"
            >
              <i
                :class="[
                  passwordType !== 'password' ? 'el-icon-remove-outline' : 'el-icon-view',
                ]"
              ></i>
            </span>
          </el-form-item>
          <!-- <el-form-item prop="code">
            <div class="flex-aitem-center">
              <el-col :span="11"
                ><el-input
                  type="text"
                  id="validateCode"
                  v-model="userForm.code"
                  placeholder="验证码"
                ></el-input
              ></el-col>
              <el-col :span="1"></el-col>
              <el-col :span="8" class="flex-aitem-center"
                ><img
                  id="validateCodeImage"
                  :src="codeimg"
                  alt
                  class="codeimg"
                  @click="getcode"
              /></el-col>
            </div>
          </el-form-item> -->
          <!-- <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox> -->
          <el-form-item style="width: 100%"
            ><el-button
              type="primary"
              style="width: 100%"
              @click="submitForm('userForm')"
              :loading="logining"
              >登录</el-button
            ></el-form-item
          >
        </el-form>
      </div>
    </div>
    <h4 style="text-align: center;color: #ffffff;">建议使用谷歌浏览器登录平台</h4>
    <h4 style="text-align: center;color: #ffffff;"><a rel="nofollow" href="http://beian.miit.gov.cn/" target="_blank"><span style="color:#a3abb1">工业和信息化部备案管理系统网站:浙ICP备20003375号-1</span></a></h4>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { setCookie, getCookie, delCookie } from "@/commons/util";
import { Base64 } from "js-base64";
import "@/commons/RSAUtil";
export default {
  name: "login",
  data() {
    return {
      passwordType: "password",
      redirect: "",
      loadImage: "",
      loginKey: null,
      logining: false,
      rememberpwd: false, // 记住密
      defaultCodeimg: "",
      NofromUrl:true,
      codeimg: "",
      userForm: {
        userAccount: "",
        userPassword: "",
        code: "",
        randomStr: "",
      },
      // rules前端验证
      rules: {
        userAccount: [{ required: true, message: "请输入账号", trigger: "blur" }],
        userPassword: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  // 创建完毕状态(里面是操作)
  // created() {
  //   // 获取图形验证码
  //   // this.getcode();
  // },
  computed: {
    ...mapGetters(["GET_APPNAME"]),
  },
  // 里面的函数只有调用才会执行
  methods: {
    ...mapMutations({
      SET_info: "SET_info", // 将 `this.add()` 映射为 `this.$store.commit('SET_USERINFO')`
    }),
    getcode() {
      this.codeimg = this.defaultCodeimg + "?t=" + new Date().getTime();
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          
          // this.$store
          //   .dispatch("user/login", {
          //     username: this.userForm.userAccount,
          //     password: this.userForm.userPassword,
          //   })
          //   .then((userInfo) => {
          //     window.localStorage.userInfo = userInfo;
          //     this.$router.push({ path: "/" });
          //     this.loading = false;
          //   })
            // .catch((err) => {
            //   this.$message.error("登录失败:" + err.msg);
            //   this.loading = false;
            // });
            let encrypts
            if(this.NofromUrl){
             encrypts = this.$aes.encrypt(this.userForm.userPassword);
            }else{
              encrypts = this.userForm.userPassword;
              this.NofromUrl = true;
            }
          
          this.$axios({
          	method: 'post',
          	url: '/dqi-oamanage/oauth/token',
            headers: {
                      "Access-Control-Allow-Origin": "*",
                      'Authorization': 'Basic ZHFpLWFkbWluOmRxaTY2ODg='
                      },
            data: {
                  'username': this.userForm.userAccount,
                  'password': encrypts,
                  'grant_type': 'password'
                },
          	timeout: 30000,
          	}).then(res => {
                if(res.code == '00000'){
                  const data = res.data
                   window.localStorage.userInfo = JSON.stringify(data);
                   this.SET_info(data)
                   window.localStorage.MP_ACCESS_TOKEN = data.access_token;
                   window.localStorage.nickname = data.nickname;
                   window.localStorage.userid = data.user_id;
                   if(data.roleType == 3)
                  {
                    this.$store.commit("topnav_activeNav1", 0);
                    const documentTitle_menuName = {mngmSsjk: "企业轿车申报"};
                    this.$store.commit("documentTitle_menuName", documentTitle_menuName);
                    this.$router.push({ name: "208" });
                  }
                   else
                    this.$router.push({ path: "/" });
                }
                else{
                  this.$message.error("登录失败:" + res.msg);
                  this.logining = false;
                }
				this.loading = false;
          	}).catch((err) => {
              this.$message.error("登录失败:" + err.msg);
              this.loading = false;
			  this.logining = false;
            });
        } else {
          // 获取图形验证码
          // this.getcode();
          this.$message.error("请输入用户名密码！");
          this.logining = false;
          return false;
        }
      });
    },
  },
  created(){
    //let decodeUrl =  decodeURIComponent(window.location.href.split('?')[1]);
    if(window.location.href.indexOf('?') > 1){
        let decodeUrl = Base64.decode(window.location.href.split('?')[1])
        if(decodeUrl != "undefined"){
            let u = decodeUrl.split('&')[0].substring(9);
            let p = decodeUrl.split('&')[1].substring(9);
            if(u!=null && p !=null ){
              this.userForm.userAccount = u;
              this.userForm.userPassword = p;
              this.NofromUrl = false;
              setTimeout(() => {
                this.submitForm('userForm');
              }, 500);
            }
        }
    }
  }
  //   watch: {
  //   '$route': {
  //     handler: function(route) {
  //       this.redirect = route.query && route.query.redirect
  //     },
  //     immediate: true
  //   }
  // },
};
</script>

<style scoped>
.el-checkbox {
  color: rgb(229, 226, 226);
}
.flex-aitem-center {
  display: flex;
  align-items: center;
}
.login-wrap {
  box-sizing: border-box;
  height: 100vh;
  padding-top: 10%;
  background-image: url("/static/img/login.jpg");
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 100%;
}

.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 370px;
  height: 360px;
  padding: 0 10px;
  padding-top: 10px;
  background: rgba(59, 68, 78, 0.3);
}
.form {
  padding: 20px;
  padding-top: 40px;
  background-image: url("/static/img/login_center.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 100%;
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #ffffff;
  font-size: 36px;
}

.remember {
  margin-bottom: 20px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/J3Klogin.vue